"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var Family_1 = require("../../../family/model/Family");

var PriceChangeIndex_1 = require("../../../product/model/PriceChangeIndex");
/**
 * Class with mathematical formulas for computing prices.
 *
 * @author Radek Beran
 */


var PriceFormulas =
/*#__PURE__*/
function () {
  function PriceFormulas() {
    _classCallCheck(this, PriceFormulas);
  }

  _createClass(PriceFormulas, null, [{
    key: "computePriceChangeIndexPercent",
    // https://docs.google.com/spreadsheets/d/14uxlkhab9sC1a_hXB6Wv957gdjrZYQXHgdZJdW0AQzM/edit#gid=2093608567
    value: function computePriceChangeIndexPercent(newPrice, oldPrice) {
      return this.computeIndex(newPrice, oldPrice);
    }
    /**
     * <p>Computes the difference between the old and the new values as percents of the old value.</p>
     * <p>Modified to work with zero old value according to PROFACT-748.</p>
     * @param newValue
     * @param oldValue
     */

  }, {
    key: "computeImpactPercent",
    value: function computeImpactPercent(newValue, oldValue) {
      if (oldValue.isZero()) {
        return newValue.isZero() ? PriceFormulas.ZERO : PriceFormulas.HUNDRED;
      }

      return newValue.minus(oldValue).div(oldValue).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Computes the accuracy of forecast.
     * @param forecastedValue
     * @param realValue
     */

  }, {
    key: "computeForecastAccuracy",
    value: function computeForecastAccuracy(forecastedValue, realValue) {
      if (realValue.isZero()) {
        return forecastedValue.isZero() ? PriceFormulas.HUNDRED : PriceFormulas.ZERO;
      }

      var denominator = realValue.greaterThanOrEqualTo(forecastedValue) ? realValue : forecastedValue;
      return big_decimal_1.BigDecimal.ONE.sub(forecastedValue.sub(realValue).abs().div(denominator)).times(PriceFormulas.HUNDRED);
    }
  }, {
    key: "computePriceElasticity",
    value: function computePriceElasticity(x) {
      return x.div(x.minus(PriceFormulas.ELASTICITY_CORRECTION));
    } // https://docs.google.com/spreadsheets/d/14uxlkhab9sC1a_hXB6Wv957gdjrZYQXHgdZJdW0AQzM/edit#gid=2093608567

  }, {
    key: "isChangeAboveThreshold",
    value: function isChangeAboveThreshold(change, threshold) {
      return change.abs().gt(threshold);
    }
    /**
     * Computes margin from sale and purchase price and vendor allowances.
     * This method internally re-computes vendor allowance percents outside 0 - 100 range (LOG-5586).
     * @param salePrice
     * @param purchasePrice
     * @param vendorAllowanceInPercent
     */

  }, {
    key: "computeMargin",
    value: function computeMargin(salePrice, purchasePrice, vendorAllowanceInPercent) {
      return salePrice.minus(purchasePrice).plus(PriceFormulas.computeVendorAllowances(purchasePrice, vendorAllowanceInPercent));
    }
    /**
     * Computes margin from sale price and purchase price with applied vendor allowances.
     * @param salePrice
     * @param purchasePriceWithVA
     */

  }, {
    key: "computeMarginFromPurchasePriceWithVA",
    value: function computeMarginFromPurchasePriceWithVA(salePrice, purchasePriceWithVA) {
      return salePrice.minus(purchasePriceWithVA);
    }
    /**
     * Profit equals sales (revenue) minus expenses.
     * @param salePrice Price a product is sold for.
     * @param purchasePrice Price a product is bought for.
     */

  }, {
    key: "computeProfit",
    value: function computeProfit(salePrice, purchasePrice) {
      return salePrice.minus(purchasePrice);
    }
    /**
     * Computes percentual margin from sale and purchase price and vendor allowances.
     * This method internally re-computes vendor allowance percents outside 0 - 100 range (LOG-5586).
     * @param salePrice
     * @param purchasePrice
     * @param vendorAllowanceInPercent
     */

  }, {
    key: "computeMarginPercent",
    value: function computeMarginPercent(salePrice, purchasePrice, vendorAllowanceInPercent) {
      return PriceFormulas.computeMargin(salePrice, purchasePrice, vendorAllowanceInPercent).div(salePrice).mul(PriceFormulas.HUNDRED);
    }
  }, {
    key: "computeProfitPercent",
    value: function computeProfitPercent(salePrice, purchasePrice) {
      // According to LOG-5028:
      return PriceFormulas.computeProfit(salePrice, purchasePrice).div(salePrice).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Computes BM1 % from aggregated absolute profit and sales.
     * @param profit BM1 summed CZK
     * @param sales Sale price summed CZK (trzba, also known as revenue)
     */

  }, {
    key: "computeProfitPercentFromAbsolute",
    value: function computeProfitPercentFromAbsolute(profit, sales) {
      // According to LOG-6468:
      return profit.div(sales).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Computes BM2 % from aggregated absolute profit and sales.
     * @param margin BM2 summed CZK
     * @param sales Sale price summed CZK (trzba, also known as revenue)
     */

  }, {
    key: "computeMarginPercentFromAbsolute",
    value: function computeMarginPercentFromAbsolute(margin, sales) {
      // According to LOG-6468:
      return margin.div(sales).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Revenue (AKA sales) for one product equals its sale price.
     * @param salePrice Price a product is sold for.
     */

  }, {
    key: "computeRevenue",
    value: function computeRevenue(salePrice) {
      return salePrice;
    }
    /**
     * Computes vendor allowance in absolute value [CZK].
     * <br/>
     * This method internally re-computes vendor allowance percents outside 0 - 100 range (LOG-5586).
     * @param purchasePrice The purchase price of a product.
     * @param vendorAllowanceInPercent The vendor allowance value in percent.
     * @param includeIfGreaterThan100 See {@link PriceFormulas.recomputeVendorAllowancePercent}.
     * @returns value of vendor allowance if any
     */

  }, {
    key: "computeVendorAllowances",
    value: function computeVendorAllowances(purchasePrice, vendorAllowanceInPercent) {
      var includeIfGreaterThan100 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      vendorAllowanceInPercent = PriceFormulas.recomputeVendorAllowancePercent(vendorAllowanceInPercent, includeIfGreaterThan100); // Default vendor allowance is zero if not available

      return vendorAllowanceInPercent !== null ? purchasePrice.mul(vendorAllowanceInPercent).div(PriceFormulas.HUNDRED) : PriceFormulas.ZERO;
    }
    /**
     * Computes purchase price with applied vendor allowances. Vendor allowances represent discount from the vendor,
     * so the resulting purchase price is lowered accordingly.
     */

  }, {
    key: "computePurchasePriceWithVA",
    value: function computePurchasePriceWithVA(purchasePrice, vendorAllowanceInPercent) {
      return purchasePrice.minus(PriceFormulas.computeVendorAllowances(purchasePrice, vendorAllowanceInPercent));
    }
    /**
     * Re-computes vendor allowances in % in case of negative or above-100 % values as stated in LOG-5586.
     * @param vaPercent Vendor allowance as percents of purchase  price to recompute.
     * @param includeIfGreaterThan100 If va in percent is greater than zero and this flag is set to true, va is included
     *        within the recalculation (using max allowed value according to LOG-5586), if the flag is set to false, va is not used at all.
     * @returns recomputed value of va in percent with respect to LOG-5586 and LOG-6403.
     */

  }, {
    key: "recomputeVendorAllowancePercent",
    value: function recomputeVendorAllowancePercent(vaPercent) {
      var includeIfGreaterThan100 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (vaPercent === null) {
        return null;
      }

      if (vaPercent.greaterThan(PriceFormulas.HUNDRED)) {
        // VA not applied if we do not want to include va greater than 100
        return includeIfGreaterThan100 ? PriceFormulas.MAX_VA_PERCENT : null;
      }

      if (vaPercent.lessThan(PriceFormulas.ZERO)) {
        return null; // VA not applied
      }

      return vaPercent;
    }
    /**
     * Computes discount in percent.
     * @param priceBeforeDiscount
     * @param priceAfterDiscount
     */

  }, {
    key: "computeDiscountPercent",
    value: function computeDiscountPercent(priceBeforeDiscount, priceAfterDiscount) {
      return priceBeforeDiscount.minus(priceAfterDiscount).div(priceBeforeDiscount).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Computes deadstock provision expressed in CZK. It is amount intended to cover losses in deadstock sell-out at discounted price.
     * See https://docs.google.com/spreadsheets/d/1OmgMuBQ3zKnlE_QfEs9McAFjUyzjcWnxmZpno2Wh67I/edit#gid=1954661732
     * and https://docs.google.com/spreadsheets/d/1OmgMuBQ3zKnlE_QfEs9McAFjUyzjcWnxmZpno2Wh67I/edit#gid=928163833
     * @param deadstockQuantity expressed in measurement unit of article; quantity of deadstock
     * @param purchasePrice purchase price without VAT (currently valid, source: GOLD)
     * @param discountInPercent % discount is the percentage value set in sellout settings for particular article based on business rules
     * (category manager-level category, age of deadstock)
     */

  }, {
    key: "computeDeadstockProvision",
    value: function computeDeadstockProvision(deadstockQuantity, purchasePrice, discountInPercent) {
      return deadstockQuantity.mul(purchasePrice).mul(discountInPercent.div(PriceFormulas.HUNDRED));
    }
    /**
     * Computes deadstock investment expressed in CZK.
     * See https://docs.google.com/spreadsheets/d/1OmgMuBQ3zKnlE_QfEs9McAFjUyzjcWnxmZpno2Wh67I/edit#gid=928163833
     * @param regularPrice regular price
     * @param finalPrice final price
     * @param deadstockQuantity expressed in measurement unit of article; quantity of deadstock
     */

  }, {
    key: "computeDeadstockInvestment",
    value: function computeDeadstockInvestment(regularPrice, finalPrice, deadstockQuantity) {
      return regularPrice.minus(finalPrice).mul(deadstockQuantity);
    }
    /**
     * Computes deadstock impact expressed in CZK.
     * @param investment deadstock investment
     * @param provision deadstock provision
     */

  }, {
    key: "computeDeadstockImpact",
    value: function computeDeadstockImpact(investment, provision) {
      return investment.plus(provision);
    }
    /**
     * Computes days left to sell out available supplies with given sell out speed (speed: forecasted sell out amount/per given days).
     * @param availableSupply
     * @param forecastDays
     * @param forecast
     */

  }, {
    key: "computeSelloutDaysLeftForSupply",
    value: function computeSelloutDaysLeftForSupply(availableSupply, forecastDays, forecast) {
      return availableSupply.mul(big_decimal_1.bigdecimal(forecastDays)).div(forecast);
    }
    /**
     * Default rounding of prices. Use this as a fallback. Rounding rules/strategies should be used.
     * @param number
     */

  }, {
    key: "roundDefault",
    value: function roundDefault(number) {
      return number.round(2);
    }
    /**
     * Computes modified competitor price. If both, size ratio and size charger, are null, it returns the original price.
     *
     * @param originalCompetitorPrice the price to be modified
     * @param sizeRatio the first modifier should be a value about 1 (0.2, 1.5, ...)
     * @param sizeChargerInPercents the second modifier should be a value in percents. It can be negative. (-20, 50)
     * @returns the modified price
     */

  }, {
    key: "computeModifiedCompetitorPrice",
    value: function computeModifiedCompetitorPrice(originalCompetitorPrice, sizeRatio, sizeChargerInPercents) {
      var sizeCharger = sizeChargerInPercents && PriceFormulas.ONE.plus(sizeChargerInPercents.dividedBy(100));
      var modifiedPriceWithRatio = sizeRatio ? originalCompetitorPrice.dividedBy(sizeRatio) : originalCompetitorPrice;
      return sizeCharger ? modifiedPriceWithRatio.times(sizeCharger) : modifiedPriceWithRatio;
    } // https://docs.google.com/spreadsheets/d/1ZJvEfOMtEFciiiH9lV_lcM2FMD0w3zElFYoMKpuDyaA/edit#gid=0

  }, {
    key: "computeInternalVsCompetitorReferencePriceChangeIndex",
    value: function computeInternalVsCompetitorReferencePriceChangeIndex(competitorReferencePrice, actualRegularPrice) {
      return this.computeIndex(competitorReferencePrice, actualRegularPrice);
    }
  }, {
    key: "computeInternalVsCompetitorReferencePriceIndex",
    value: function computeInternalVsCompetitorReferencePriceIndex(regularPrice, crp) {
      return regularPrice.minus(crp).div(crp).mul(PriceFormulas.HUNDRED);
    }
  }, {
    key: "computeIndex",
    value: function computeIndex(value1, value2) {
      return value1.minus(value2).div(value2).mul(PriceFormulas.HUNDRED);
    }
    /**
     * Returns 1.12 for input 12 or 0.85 for -15.
     * @param percent Value which is checked and transformed to ration
     * @param title Description of the value. It is used in case of validation error.
     * @param min Minimum correct value. If the value of the percent parameter is smaller, then error will be thrown.
     */

  }, {
    key: "computeRatioFromPercentageIncrease",
    value: function computeRatioFromPercentageIncrease(percent, title, min) {
      if (percent.comparedTo(big_decimal_1.bigdecimal(min)) >= 0) {
        var hundred = PriceFormulas.HUNDRED;
        var numerator = hundred.add(percent);
        return numerator.div(hundred);
      } else {
        throw new Error("".concat(title, " has not to be smaller than ").concat(min, ". Current value ").concat(percent, "."));
      }
    }
    /**
     * Combines a size ratio and a charger to one value which is used during price's optimization.
     * @param binding Product's ID with the size ratio and the charger.
     */

  }, {
    key: "computeLineAmount",
    value: function computeLineAmount(binding) {
      var zero = PriceFormulas.ZERO;
      var sizeRatio = binding.sizeRatio !== null ? binding.sizeRatio : PriceFormulas.ONE;

      if (sizeRatio.comparedTo(Family_1.Family.SIZE_RATIO_MIN) < 0) {
        throw new Error("Size ratio cannot be under ".concat(Family_1.Family.SIZE_RATIO_MIN, ".") + "Current value for product ".concat(binding.productId, ": ").concat(sizeRatio.toNumber()));
      }

      var sizeCharger = binding.sizeCharger !== null ? binding.sizeCharger : zero;
      var sizeChargerTitle = "Size charger for product ".concat(binding.productId);
      var sizeChargerRation = PriceFormulas.computeRatioFromPercentageIncrease(sizeCharger, sizeChargerTitle, Family_1.Family.SIZE_CHARGER_MIN);
      return sizeRatio.mul(sizeChargerRation);
    }
    /**
     * Computes (100 + size charger in %)/100 * price. Negative size charger results in lower price.
     */

  }, {
    key: "computePriceWithChargerEffect",
    value: function computePriceWithChargerEffect(price, sizeChargerPercent) {
      return PriceFormulas.HUNDRED.plus(sizeChargerPercent).div(PriceFormulas.HUNDRED).mul(price);
    }
    /**
     * Computes (100 * price)/(100 + size charger in %). Result is normalized price without considering charger effect.
     */

  }, {
    key: "computePriceWithoutChargerEffect",
    value: function computePriceWithoutChargerEffect(price, sizeChargerPercent) {
      return PriceFormulas.HUNDRED.mul(price).div(PriceFormulas.HUNDRED.plus(sizeChargerPercent));
    }
    /**
     * <p>
     * Computes (100 / (100 - minMarginChangeInPercent)) * (purchasePrice - VA of purchase price).
     * If value of va in percent is greater than 100 % or lower than 0 %, VA is not used (LOG-6403). Result is minimum range used for input
     * of sellout price calculation.
     * </p>
     *
     * <p>Since PROFACT-608, if `maxPriceChangeInPercent` is specified, computed price mustn't be lower than
     * (1 - maxPriceChangeInPercent / 100) * salePrice.</p>
     *
     * <p>
     * Used for sellout price calculation. Move this to somewhere else? It is specific formula.
     * </p>
     *
     * @param purchasePrice value of product purchase price
     * @param salePrice value of sale price
     * @param minMarginChangeInPercent minimal price change that should be applied to current regular price
     * @param maxPriceChangeInPercent maximum price change allowed (added in PROFACT-608)
     * @param vaInPercent vendor allowances in percent
     * @returns computed minimum price range
     * @throws error if minMarginChangeInPercent is greater or equal to 100 %.
     */

  }, {
    key: "computeMinimumPriceRange",
    value: function computeMinimumPriceRange(purchasePrice, salePrice, minMarginChangeInPercent, maxPriceChangeInPercent, vaInPercent) {
      if (minMarginChangeInPercent.greaterThanOrEqualTo(100)) {
        throw new Error("Minimum margin change in percent cannot be greater or equal to 100 %!");
      }

      if (maxPriceChangeInPercent && maxPriceChangeInPercent.greaterThanOrEqualTo(100)) {
        throw new Error("Maximum price change in percent cannot be greater or equal to 100 %!");
      } // LOG-6403 we do not want to use va if greater than 100 %


      var vaOfPurchasePrice = PriceFormulas.computeVendorAllowances(purchasePrice, vaInPercent, false);
      purchasePrice = purchasePrice.minus(vaOfPurchasePrice);
      var priceByMinMarginChange = PriceFormulas.HUNDRED.div(PriceFormulas.HUNDRED.minus(minMarginChangeInPercent)).mul(purchasePrice); // PROFACT-608 limiting max change by `maxPriceChangeInPercent` if specified

      var priceByMaxPriceChange = maxPriceChangeInPercent && salePrice ? PriceFormulas.ONE.minus(maxPriceChangeInPercent.div(PriceFormulas.HUNDRED)).mul(salePrice) : PriceFormulas.ZERO;
      return priceByMinMarginChange.max(priceByMaxPriceChange);
    }
    /**
     * Computes (1 - minPriceChangeInPercent / 100) * salePrice. Result is maximum range used for input of sellout price calculation.
     *
     * Used for sellout price calculation. Move this to somewhere else? It is specific formula.
     *
     * @param salePrice value of sale price
     * @param minPriceChangeInPercent minimal price change that should be applied to current regular (sale) price
     * @returns computed maximum price range
     */

  }, {
    key: "computeMaximumPriceRange",
    value: function computeMaximumPriceRange(salePrice, minPriceChangeInPercent) {
      return PriceFormulas.ONE.minus(minPriceChangeInPercent.div(PriceFormulas.HUNDRED)).mul(salePrice);
    }
    /**
     * <p>
     * Computes (selloutStockAmount / oldForecastQuantity - 1) * 100. Result is percentage change (delta) of quantity based on sellout
     * stock amount and forecast for old price. Provided forecast for old price (sale price) should be weighted according to number of days
     * remaining to the end of sellout.
     * </p>
     *
     * <ul>
     *     <li>If sellout stock amount is bigger than forecast, result is positive percentage number of growth.</li>
     *     <li>If sellout stock amount is lower, result is negative percentage number of growth (it is actual decrease).</li>
     *     <li>If sellout stock amount is equal to forecast, result is zero percentage number of growth.</li>
     *
     * <p>Special cases:</p>
     *
     * <ul>
     *     <li>if old forecast is zero, it returns infinity.</li>
     *     <li>if given forecast or sellout stock amount is negative number, it throws an error.</li>
     * </ul>
     *
     * @param oldForecastQuantity Forecast for old price.
     * @param selloutStockAmount Amount of stock in a sellout.
     * @returns Percentage change of quantity based on given forecast and sellout stock amount.
     * @throws an error if given forecast or sellout stock amount is negative number
     */

  }, {
    key: "computePercentageChangeOfQuantity",
    value: function computePercentageChangeOfQuantity(oldForecastQuantity, selloutStockAmount) {
      if (oldForecastQuantity.isNegative() || selloutStockAmount.isNegative()) {
        throw new Error("Forecast (".concat(oldForecastQuantity, ") or sellout stock amount (").concat(selloutStockAmount, ") cannot be lower than zero!"));
      }

      if (oldForecastQuantity.isZero()) {
        return big_decimal_1.bigdecimal(Infinity);
      }

      return selloutStockAmount.div(oldForecastQuantity).minus(PriceFormulas.ONE).mul(PriceFormulas.HUNDRED);
    }
    /**
     * <p>Computes changeOfQuantityInPercent / elasticity. Result is the final percentage price change based on given change of quantity and
     * price elasticity.</p>
     *
     * @param changeOfQuantityInPercent Percentage change (delta) of quantity based on percentage change of quantity and given elasticity.
     * @param elasticity Coefficient of price elasticity.
     * @returns Final percentage price change based on given parameters.
     */

  }, {
    key: "computeFinalPercentagePriceChange",
    value: function computeFinalPercentagePriceChange(changeOfQuantityInPercent, elasticity) {
      // how to validate elasticity?
      if (elasticity.isZero()) {
        return PriceFormulas.ZERO; // return zero for final percentage or infinite?
      }

      return changeOfQuantityInPercent.div(elasticity);
    }
    /**
     * Computes salePrice + salePrice * (salePriceChange / 100). Result is final sellout price, but you should verify it with other
     * business rules.
     *
     * @param salePrice value of sale price
     * @param salePriceChange final percentage price change based on given sale price.
     * @returns final sellout price (but remember, you should verify it).
     */

  }, {
    key: "computeFinalSelloutPrice",
    value: function computeFinalSelloutPrice(salePrice, salePriceChange) {
      return salePrice.plus(salePrice.mul(salePriceChange.div(PriceFormulas.HUNDRED)));
    }
    /**
     * Computes number of days for given price validity interval
     * (including the day from the beginning of start day and the day to the end of end day).
     * Returns max. maxDays days, not more
     * (e.g. if end date represents date in far future).
     * @param start
     * @param end
     * @param maxDays
     */

  }, {
    key: "computeDaysInPriceInterval",
    value: function computeDaysInPriceInterval(start, end, maxDays) {
      var startDay = start.clone().startOf('day');
      var endDay = end.clone().endOf('day').add(1, 'hour'); // so the end date is included in the result as well

      if (startDay.isSameOrAfter(endDay)) {
        return 0;
      }

      var daysDiff = endDay.clone().diff(startDay, 'days');

      if (daysDiff > maxDays) {
        return maxDays;
      }

      return daysDiff;
    }
    /**
     * Returns true if new value is not the same as old value (or state of filling differs).
     * @param oldValue
     * @param newValue
     */

  }, {
    key: "valueHasChanged",
    value: function valueHasChanged(oldValue, newValue) {
      if (oldValue === null && newValue === null) {
        return false;
      }

      if (oldValue === null && newValue !== null || newValue === null && oldValue !== null) {
        return true;
      }

      return !newValue.equals(oldValue);
    }
    /**
     * Returns true if new value is not the same as old value (or state of filling - null/not null - differs).
     * @param oldValue
     * @param newValue
     */

  }, {
    key: "dateHasChanged",
    value: function dateHasChanged(oldValue, newValue) {
      if (oldValue === null && newValue === null) {
        return false;
      }

      if (oldValue === null && newValue !== null || newValue === null && oldValue !== null) {
        return true;
      }

      return !newValue.isSame(oldValue);
    }
  }, {
    key: "computeCompanyVsReferencePriceChangeIndexPercent",
    value: function computeCompanyVsReferencePriceChangeIndexPercent(finalPrice, referencePrice, companyVsCompetitorRPChangeIndexThreshold) {
      var companyVsReferencePriceChangeIndexPercentValue = referencePrice && referencePrice.value && finalPrice ? PriceFormulas.roundDefault(PriceFormulas.computePriceChangeIndexPercent(finalPrice.getPresentedValue(), referencePrice.value)) : null;
      var companyVsReferencePriceChangeIndexAboveThreshold = companyVsReferencePriceChangeIndexPercentValue ? PriceFormulas.isChangeAboveThreshold(companyVsReferencePriceChangeIndexPercentValue, companyVsCompetitorRPChangeIndexThreshold) : false;
      return companyVsReferencePriceChangeIndexPercentValue ? new PriceChangeIndex_1.PriceChangeIndex(companyVsReferencePriceChangeIndexPercentValue, companyVsReferencePriceChangeIndexAboveThreshold) : null;
    }
  }, {
    key: "computeRegularPriceChangeIndexPercent",
    value: function computeRegularPriceChangeIndexPercent(finalPrice, regularPrice, finalPriceChangeIndexThreshold) {
      var regularPriceChangeIndexPercentValue = regularPrice && regularPrice.getPresentedValue() && finalPrice ? PriceFormulas.roundDefault(PriceFormulas.computePriceChangeIndexPercent(finalPrice.getPresentedValue(), regularPrice.getPresentedValue())) : null;
      var regularPriceChangeIndexAboveThreshold = regularPriceChangeIndexPercentValue ? PriceFormulas.isChangeAboveThreshold(regularPriceChangeIndexPercentValue, finalPriceChangeIndexThreshold) : false;
      return regularPriceChangeIndexPercentValue ? new PriceChangeIndex_1.PriceChangeIndex(regularPriceChangeIndexPercentValue, regularPriceChangeIndexAboveThreshold) : null;
    }
  }, {
    key: "computeAvailableSupplyPriceChange",
    value: function computeAvailableSupplyPriceChange(initialStockVolume, stockVolume) {
      return initialStockVolume && stockVolume ? initialStockVolume.minus(stockVolume) : null;
    }
  }, {
    key: "computeAvailableSupplyChange",
    value: function computeAvailableSupplyChange(initialStockValue, stockValue) {
      return initialStockValue && stockValue ? initialStockValue.minus(stockValue) : null;
    }
  }, {
    key: "computeAvailableSupplyPriceChangePercent",
    value: function computeAvailableSupplyPriceChangePercent(initialStockValue, stockValue) {
      return initialStockValue && stockValue && !initialStockValue.equals(PriceFormulas.ZERO) ? initialStockValue.minus(stockValue).dividedBy(initialStockValue).mul(100) : null;
    }
  }, {
    key: "computeAvailableSupplyChangePercent",
    value: function computeAvailableSupplyChangePercent(initialStockVolume, stockVolume) {
      return initialStockVolume && stockVolume && !initialStockVolume.equals(PriceFormulas.ZERO) ? initialStockVolume.minus(stockVolume).dividedBy(initialStockVolume).mul(100) : null;
    }
    /**
     * Computes net price (price without VAT) from given gross price and VAT % rate.
     * @param grossPrice
     * @param vatPercentRate
     */

  }, {
    key: "computeNetPrice",
    value: function computeNetPrice(grossPrice, vatPercentRate) {
      return grossPrice.mul(PriceFormulas.HUNDRED).div(PriceFormulas.HUNDRED.plus(vatPercentRate));
    }
    /**
     * Computes gross price from given net price and VAT % rate.
     * @param netPrice
     * @param vatPercentRate
     */

  }, {
    key: "computeGrossPrice",
    value: function computeGrossPrice(netPrice, vatPercentRate) {
      return netPrice.plus(vatPercentRate.div(PriceFormulas.HUNDRED).mul(netPrice));
    }
  }, {
    key: "finalPriceDiffersFromRegular",
    value: function finalPriceDiffersFromRegular(finalPrice, regularPrice) {
      // Rounded final price (presented value) is exported
      var regularPriceValue = regularPrice !== null ? regularPrice.getPresentedValue() : null;
      return this.compareFinalPriceWithAnotherPrice(finalPrice, regularPriceValue);
    }
  }, {
    key: "finalPriceDiffersFromEDLP",
    value: function finalPriceDiffersFromEDLP(finalPrice, edlpPrice) {
      var edlpValue = edlpPrice !== null ? edlpPrice.value : null;
      return this.compareFinalPriceWithAnotherPrice(finalPrice, edlpValue);
    }
  }, {
    key: "computePromoPurchasePricePlus",
    value: function computePromoPurchasePricePlus(regPurchasePrice, regPurchasePriceNett, promoPurchasePrice) {
      return regPurchasePrice.minus(regPurchasePriceNett).plus(promoPurchasePrice);
    }
  }, {
    key: "compareFinalPriceWithAnotherPrice",
    value: function compareFinalPriceWithAnotherPrice(finalPrice, regularPriceValue) {
      var finalPriceValue = finalPrice !== null ? finalPrice.getPresentedValue() : null;

      if (finalPriceValue === null && regularPriceValue === null) {
        return false;
      }

      if (finalPriceValue === null || regularPriceValue === null) {
        return true;
      }

      return !finalPriceValue.equals(regularPriceValue);
    }
  }]);

  return PriceFormulas;
}();

exports.PriceFormulas = PriceFormulas;
PriceFormulas.ONE = big_decimal_1.bigdecimal(1);
PriceFormulas.ZERO = big_decimal_1.bigdecimal(0);
PriceFormulas.TEN = big_decimal_1.bigdecimal(10);
PriceFormulas.HUNDRED = big_decimal_1.bigdecimal(100);
PriceFormulas.ELASTICITY_CORRECTION = big_decimal_1.bigdecimal(1.1);
PriceFormulas.MAX_VA_PERCENT = big_decimal_1.bigdecimal(99.9); // defined in LOG-5586

PriceFormulas.NAN = big_decimal_1.bigdecimal(NaN);